export default __webpack_public_path__ + "static/media/Desk-Dale.a1e82f2b.svg";